<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="new-practice-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="new-practice-form" @submit.prevent="onSubmit">
        <div class="new-practice-form-body">
          <v-toolbar flat height="76">
            <v-toolbar-title class="new-practice-toolbar-title"
              >Add Company</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn color="accent" icon tile @click="closeDialog">
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- practice -->
          <v-card-title class="new-practice-card-title pb-0"
            >Company data</v-card-title
          >
          <v-container class="new-practice-card-container pt-0">
            <dialog-input label="Name" name="name" @input="onInput" />
          </v-container>
          <v-container class="new-practice-card-container pt-0">
            <dialog-input label="Type" name="type" @input="onInput" />
          </v-container>
          <v-container class="new-practice-card-container pt-0">
            <dialog-input label="Address" name="address" @input="onInput" />
          </v-container>
          <v-container class="new-practice-card-container pt-0">
            <dialog-input
              label="Email address"
              name="email"
              prepend-icon="mdi-email-outline"
              @input="onInput"
              :validate="true"
              :validationType="'email'"
            />
          </v-container>
          <v-container class="new-practice-card-container pt-0">
            <dialog-input
              label="Phone number"
              name="phoneNo"
              prepend-icon="mdi-cellphone-iphone"
              @input="onInput"
            />
          </v-container>

          <!-- contact -->
          <v-card-title class="new-practice-card-title"
            >Primary contact</v-card-title
          >
          <v-container class="new-practice-card-container py-0">
            <v-row>
              <v-col class="new-practice-form-col-left" sm="6">
                <dialog-input
                  label="First name"
                  name="pcFirstName"
                  @input="onInput"
                />
              </v-col>
              <v-col class="new-practice-form-col-right" sm="6">
                <dialog-input
                  label="Last name"
                  name="pcLastName"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-practice-card-container py-0">
            <v-row>
              <v-col class="new-practice-form-col-left" sm="6">
                <dialog-input
                  label="Email address"
                  name="pcEmail"
                  prepend-icon="mdi-email-outline"
                  @input="onInput"
                  :validate="true"
                  :validationType="'email'"
                />
              </v-col>
              <v-col class="new-practice-form-col-right" sm="6">
                <dialog-input
                  label="Phone number"
                  name="pcPhoneNo"
                  prepend-icon="mdi-cellphone-iphone"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-card-title class="new-practice-card-title"
            >Feature Settings</v-card-title
          >
          <v-container class="new-practice-card-container py-0">
            <v-row>
              <v-col class="new-practice-form-col-left">
                <bh-select
                  class="mb-3"
                  :disabled="!isAnyAdminRole"
                  :label="tenantTexts.addPracticeDialog.swapFlag"
                  v-model="newUserData.swapAvailable"
                  :items="computedFeatureFlagsSwap"
                  item-text="text"
                  item-value="value"
                  solo
                  background-color="#ffffff"
                  @input="changeFeatureFlag('swapAvailable', $event)"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container
            class="new-practice-card-container py-0"
            v-if="featuresSettings.VUE_FEATURE_SMART_SURVEY"
          >
            <v-row>
              <v-col class="new-practice-form-col-left">
                <bh-select
                  class="mb-3"
                  :disabled="!isAnyAdminRole"
                  :label="tenantTexts.addPracticeDialog.smartSurveyFlag"
                  v-model="newUserData.smartSurveyAvailable"
                  :items="computedFeatureFlagsSmartSurvey"
                  item-text="text"
                  item-value="value"
                  solo
                  background-color="#ffffff"
                  @input="changeFeatureFlag('smartSurveyAvailable', $event)"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-practice-card-container py-0">
            <v-row>
              <v-col class="new-practice-form-col-left">
                <bh-select
                  class="mb-3"
                  :disabled="!roleAllowedToManageJournalFlag"
                  :label="tenantTexts.addPracticeDialog.journalFlag"
                  v-model="newUserData.journalAvailable"
                  :items="computedFeatureFlagsJournal"
                  item-text="text"
                  item-value="value"
                  solo
                  background-color="#ffffff"
                  @input="changeFeatureFlag('journalAvailable', $event)"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container
            class="new-practice-card-container py-0"
            v-if="featuresSettings.VUE_FEATURE_SCREENER"
          >
            <v-row>
              <v-col class="new-practice-form-col-left">
                <bh-select
                  class="mb-3"
                  :disabled="!isAnyAdminRole"
                  :label="tenantTexts.addPracticeDialog.surveyFlag"
                  v-model="newUserData.surveyAvailable"
                  :items="computedFeatureFlagsSurvey"
                  item-text="text"
                  item-value="value"
                  solo
                  background-color="#ffffff"
                  @input="changeFeatureFlag('surveyAvailable', $event)"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
        <v-container class="new-practice-card-footer d-flex justify-end">
          <v-btn
            :disabled="!formIsValid"
            rounded
            color="primary"
            type="submit"
            elevation="0"
          >
            Add company
          </v-btn>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import DialogInput from '@/components/forms/DialogInput.vue'
import BhSelect from '@/components/inputs/BhSelect.vue'
import TenantTextsMixin from '@/mixins/tenantTexts'
import FeaturesSettingsMixin from '@/mixins/featuresSettings'

const emptyForm = {
  name: '',
  address: '',
  email: '',
  phoneNo: '',
  //type ??

  journalAvailable: 'Active',
  smartSurveyAvailable: 'Active',
  swapAvailable: 'Active',
  surveyAvailable: 'Inactive', // Screener
  participantLandingPage: '',

  // contact
  pcFirstName: '',
  pcLastName: '',
  pcPhoneNo: '',
  pcEmail: '',
  isActive: true,
}

export default {
  name: 'NewPracticeDialog',
  components: {
    DialogInput,
    BhSelect,
  },
  mixins: [TenantTextsMixin, FeaturesSettingsMixin],
  props: {
    swapAvailable: {
      type: String,
      default: 'Active',
    },
    smartSurveyAvailable: {
      type: String,
      default: 'Active',
    },
    journalAvailable: {
      type: String,
      default: 'Active',
    },
    surveyAvailable: {
      type: String,
      default: 'Inactive',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      newUserData: {
        ...emptyForm,
        journalAvailable: this.journalAvailable || emptyForm.journalAvailable,
        smartSurveyAvailable:
          this.smartSurveyAvailable || emptyForm.smartSurveyAvailable,
        swapAvailable: this.swapAvailable || emptyForm.swapAvailable,
        surveyAvailable: this.surveyAvailable || emptyForm.surveyAvailable,
      },
      rules: {
        text: [v => !!v || 'Value cannot by empty'], // @todo
      },
    }
  },
  watch: {
    swapAvailable: function(val) {
      if (val) {
        this.newUserData.swapAvailable = val
      }
    },
    smartSurveyAvailable: function(val) {
      if (val) {
        this.newUserData.smartSurveyAvailable = val
      }
    },
    journalAvailable: function(val) {
      if (val) {
        this.newUserData.journalAvailable = val
      }
    },
    surveyAvailable: function(val) {
      if (val) {
        this.newUserData.surveyAvailable = val
      }
    },
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
    },
  },
  computed: {
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('dictionariesStates', [
      'dictionaryBhUsersRoleIds',
      'dictionaryPracticeUserRole',
      'dictionaryFeatureFlagState',
    ]),
    isAnyAdminRole() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
          this.dictionaryBhUsersRoleIds.Admin ||
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Administrator
      )
    },
    roleAllowedToManageJournalFlag() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
          this.dictionaryBhUsersRoleIds.Admin ||
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Administrator ||
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Advisor
      )
    },
    computedFeatureFlagsJournal() {
      return [
        {
          text: 'Journal & Metrics',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Active
          ],
        },
        {
          text: 'Journal only',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Partial
          ],
        },
        {
          text: 'Journal off',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Inactive
          ],
        },
      ]
    },
    computedFeatureFlagsSmartSurvey() {
      return [
        {
          text: 'Full survey',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Active
          ],
        },
        {
          text: 'Initial questions only',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Partial
          ],
        },
        {
          text: 'Survey off',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Inactive
          ],
        },
      ]
    },
    computedFeatureFlagsSwap() {
      return [
        {
          text: 'Active',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Active
          ],
        },
        {
          text: 'Inactive',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Inactive
          ],
        },
      ]
    },
    computedFeatureFlagsSurvey() {
      return [
        {
          text: 'Active',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Active
          ],
        },
        {
          text: 'Inactive',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Inactive
          ],
        },
      ]
    },
    formIsValid() {
      return (
        this.newUserData.name &&
        this.newUserData.journalAvailable &&
        this.newUserData.smartSurveyAvailable &&
        this.newUserData.swapAvailable &&
        this.newUserData.surveyAvailable
      )
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    changeFeatureFlag(key, value) {
      this.onInput({ name: key, value })
    },
    onInput({ name, value }) {
      this.newUserData[name] = value
    },
    clearForm() {
      this.$refs.form.reset()
      this.newUserData = {
        ...emptyForm,
        journalAvailable: this.journalAvailable || emptyForm.journalAvailable,
        smartSurveyAvailable:
          this.smartSurveyAvailable || emptyForm.smartSurveyAvailable,
        swapAvailable: this.swapAvailable || emptyForm.swapAvailable,
        surveyAvailable: this.surveyAvailable || emptyForm.surveyAvailable,
      }
    },
    onSubmit() {
      this.$emit('on-submit', { ...this.newUserData })
      this.clearForm()
      this.closeDialog()
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.new-practice {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
    .bh-select-label {
      font-size: inherit;
      font-weight: inherit;
    }
  }
}
</style>
